import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bolsatrabajo',
  templateUrl: './bolsatrabajo.component.html',
  styles: []
})
export class BolsatrabajoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
